import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const HeartIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5 10.1711C5 7.86748 6.74112 6 8.88889 6C10.161 6 11.2905 6.65515 12 7.66804C12.7095 6.65515 13.839 6 15.1111 6C17.2589 6 19 7.86748 19 10.1711C19 13.8892 12 18 12 18C12 18 5 13.8892 5 10.1711Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { HeartIcon };
